<template>
    <div>
        <slot></slot>
        <confirm-modal
            :show-confirm="showConfirm"
            @ok="ok"
            @cancel="cancel"
            :confirm-message="confirmMessage">
        </confirm-modal>
    </div>
</template>

<script>

import ConfirmModal from './ConfirmModal.vue';
import $ from 'jquery';

export default {
    props: ['confirmMessage'],
    components: {
        ConfirmModal
    },
    data() {
        return {
            showConfirm: false,
            triggerIsActive: true
        }
    },
    methods: {
        submit(event) {
            if (this.triggerIsActive) {
                event.preventDefault();
                this.showConfirm = true;
            }
        },
        ok() {
            this.showConfirm = false;
            console.log($(this.$el), $(this.$el).find('form').get(0))
            $(this.$el).find('form').get(0).submit();
        },
        cancel() {
            this.showConfirm = false;
        },
        confirmTrigger(triggerIsActive) {
            this.triggerIsActive = triggerIsActive
        },
        setTrigger(value) {
            this.triggerIsActive = !value
        }
    },
    mounted() {
        this.$root.$on('submit', this.submit);
        this.$root.$on('confirmTrigger', this.confirmTrigger);
        this.$root.$on('setTrigger', this.setTrigger);
    }
}
</script>
